var $de9db17bbab00a4e$exports = {};
console.log("hello world");


//# sourceMappingURL=majority-site.21ca1d4f.js.map
